import React from "react";
import "./WhyRentalCompany.css";


import heroBg1 from "../../assets/loftone.webp";
import heroBg2 from "../../assets/logttwo.webp";
import heroBg3 from "../../assets/loftthree.webp";

const FEATURES = [
  {
    title: "A Landmark With Character",
    desc: "The Harmon Building offers a work environment full of history and charm. With exposed timbers, high ceilings, and preserved artifacts, the space blends heritage with modern functionality.",
    img: heroBg1,
    alt: "Maintenance professional working in a stylish Harmon loft apartment",

  },
  {
    title: "Convenience at Your Doorstep",
    desc: "With secure parking and access to Tacoma’s light rail, The Harmon Building keeps you connected. It’s steps from the waterfront, restaurants, museums, and the University of Washington Tacoma.",
    img: heroBg2,
    alt: "Resident reviewing digital lease agreement in a Harmon loft",
  
  },
  {
    title: "Full-Service, Flexible Offices",
    desc: "We provide full-service leases at competitive rates, with options for tenant improvements. Multiple high-speed internet providers and potential exterior signage give your business room to grow.",
    img: heroBg3,
    alt: "Transparent pricing display showing clear cost breakdown for Harmon residences",
  
  }
];

export default function PropertyRental({
  heading = "Why Choose the Historic Harmon?",
  sub = "Distinctive office and living spaces with full-service convenience."
}) {
  return (
    <section className="property-rental">
      <div className="property-rental__container">
        <header className="property-rental__header">
          <div className="property-rental__heading-wrapper">
            <h2 className="property-rental__title">{heading}</h2>
            <p className="property-rental__subtitle">
              {sub}
              <span className="property-rental__underline" aria-hidden="true" />
            </p>
          </div>
        </header>

        <div className="property-rental__grid">
          {FEATURES.map((feature, index) => (
            <article className="property-card" key={index}>
              <div className="property-card__inner">
                <div className="property-card__media">
                  <div className="property-card__image-container">
                    <img 
                      src={feature.img} 
                      alt={feature.alt} 
                      loading="lazy" 
                      className="property-card__image"
                    />
                    <div className="property-card__overlay"></div>
                  </div>
              
                </div>
                
                <div className="property-card__content">
                  <h3 className="property-card__title">{feature.title}</h3>
                  <p className="property-card__desc">{feature.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}